<template>
  <div class="home" >
    <v-row>
      <v-col cols="12" lg="8" xl="9">
        <v-row>
          <v-col cols="12">
            <slider :data="sliders" v-if="sliders?.length>0"></slider>
          </v-col>
          <v-col cols="12" md="6" lg="6" xl="3">
            <dashboard-item to="Enrollment" color="green" icon="mdi-clock-outline" title="Chấm công" subtitle="Check-in(out)"></dashboard-item>
          </v-col>
          
          <v-col cols="12" md="6" lg="6" xl="3">
            <dashboard-item to="LeaveRequest" color="indigo" icon="mdi-note-text-outline" title="Phép Off" subtitle="Đơn nghỉ phép"></dashboard-item>
          </v-col>
          
          <v-col cols="12" md="6" lg="6" xl="3">
            <dashboard-item to="BusinessRequest" color="cyan" icon="mdi-note-text-outline" title="Công tác" subtitle="Đơn công tác"></dashboard-item>
          </v-col>

          <v-col cols="12" md="6" lg="6" xl="3">
            <dashboard-item to="OvertimeRequest" color="red" icon="mdi-note-text-outline" title="Làm thêm" subtitle="Đơn làm thêm, OT"></dashboard-item>
          </v-col>
          
          <v-col cols="12" md="6" lg="6" xl="3">
            <dashboard-item to="ConfirmTimesheetPersonal" color="red" :darken="true" icon="mdi-calendar-question" title="Hỗ trợ" subtitle="Duyệt công trễ"></dashboard-item>
          </v-col>

          <v-col cols="12" md="6" lg="6" xl="3">
            <dashboard-item to="InfoUpdate" color="orange" icon="mdi-badge-account" title="Cập nhật thông tin" subtitle="Thông tin cá nhân"></dashboard-item>
          </v-col>
          
          <!-- <v-col cols="12" md="6" lg="6" xl="3">
            <a href="https://hocvientrungson.welearning.vn/login" style="text-decoration: none; color: inherit;" target="_blank">
              <v-card class="d-flex rounded-xl" flat >
                <v-avatar class="rounded-lg" size="86" color="light-blue lighten-5">
                  <v-icon color="light-blue" large>mdi-bookshelf</v-icon>
                </v-avatar>
                <v-sheet>
                  <v-card-title class="text-body-2 text--secondary font-weight-regular" style="">
                    E-Learning
                  </v-card-title>
                  <v-card-subtitle class="font-weight-bold text-subtitle-1">
                    Hệ thống đào tạo
                  </v-card-subtitle>
                </v-sheet>
              </v-card>
            </a>
          </v-col> -->
          
          <v-col cols="12" md="6" lg="6" xl="3">
            <dashboard-item to="ItSupport" color="teal" icon="mdi-face-agent" title="IT-24H" subtitle="Phiếu hỗ trợ"></dashboard-item>
          </v-col>
          
          <v-col cols="12" md="6" lg="6" xl="3">
            <dashboard-item avatarUrl="/static/QR_Elearning_App.jpg" to="RedirectElearningDownload"
            color="light-blue " icon="mdi-bookshelf" title="E-Learning" subtitle="Quét QR để tải về"></dashboard-item>
          </v-col>

          <v-col cols="12" md="6" lg="6" xl="3">
            <dashboard-item avatarUrl="/static/app_qr3.png" 
            :onClick="osDownload" color="indigo " icon="mdi-cellphone-arrow-down" title="Tải app HRM" subtitle="Quét QR để tải về"></dashboard-item>
          </v-col>

          
          <v-subheader class="font-weight-bold text-subtitle-1" style="width: 100%; height: 32px;">
            Tin tức
            <v-spacer></v-spacer>
            <v-icon color="teal darken-4" left @click="scrollLeft">mdi-arrow-left</v-icon>
            <v-icon color="teal darken-4" right @click="scrollRight">mdi-arrow-right</v-icon>
          </v-subheader>
          <v-col cols="12">
            <media ref="media" :data="news"></media>
          </v-col>

          <geo-location></geo-location>
        </v-row>
      </v-col>
      <v-col cols="12" lg="4" xl="3">
        <v-card color="" flat style="min-height: 800px;" class="rounded-xl">
          
          <v-card-title class="text-subtitle-1 font-weight-bold">
            <!-- <v-icon left color="green">mdi-av-timer</v-icon>  -->
            Lịch sử chấm công
          </v-card-title>
          <v-card-text>
            <v-card flat class="rounded-xl" color="grey lighten-4">
              <v-card-text class="">
              <v-data-table id="enroll_table" style="border-radius: 24px; overflow: hidden;" fixed-header mobile-breakpoint="9000" hide-default-footer :items-per-page="-1" height="400px" 
                :headers="enrollHeader" dense
                :items="enrollHistory" >
                    <template v-slot:[`item.enrollDate`]="{item}">
                      <b class="">{{item.enrollDate}}</b>
                    </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-card-text>
            
          <v-card-title class="text-subtitle-1 font-weight-bold">
            <!-- <v-icon color="green" left>mdi-calendar-outline</v-icon> -->
            {{ $t("employee_page.home.schedule") }}
          </v-card-title>
          <v-card-text>
            <v-card flat class="rounded-xl" color="grey lighten-4">
              <v-card-text>
                <v-calendar
                  ref="calendar" locale="vi"
                  v-model="value"
                  mode="column"
                  :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                  type="month"
                  :events="workEvents"
                  event-text-color="black"
                  :event-overlap-threshold="30"
                  @change="getEvents"
                ></v-calendar>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-col>
      
    </v-row>
  </div>
</template>

<style scoped>

</style>
<script>
// @ is an alias to /src
import myBreadCrumb from '@/components/BreadCrumb';
import http from '@/components/services/http-common';
import Clock from '@/components/Clock.vue';
import MediaSection from '@/components/MediaSection.vue';
import moment from 'moment';
import StackedChart from '@/components/Charts/StackedChart.vue';
import Media from './Media.vue';
import Slider from './Slider.vue';
import DashboardItem from '@/components/Dashboard/DashboardItem.vue';
import {getContents} from './api'
import GeoLocation from '../../../components/GeoLocation.vue';

export default {
  name: 'Home',
  components: {
    MediaSection,
    myBreadCrumb,
    "clock": Clock,
    StackedChart,
    Media,
    Slider,
    DashboardItem,
    GeoLocation
  },
  computed:{
    popNewsDialog: {
      get: function () {
        return this.popNews.length>0
      },
      set: function (val){
        console.log(val);
        this.$emit("input", val)
      }
    },
    user () {
      let user = localStorage.getItem("user");
      user = JSON.parse(user);
      return user;
    },
    events() {
      let results = [];
      let startMonth = moment().startOf("month");
      let endMonth = moment().endOf("month");
      while(startMonth<= endMonth)
      {
        results.push({
          start: startMonth.format("YYYY-MM-DD"),
          name: "Chưa phân công",
          color: "blue-grey"
        })
        startMonth.add(1, 'days');
      }
      
      this.schedules.forEach(x=> {
        results[results.findIndex(el => el.start === x.start)] = {start: x.start, name: x.name, color: x.color};
      })
      return results;
    }
  },
  data(){
        return {
          token: localStorage.getItem("token"),
          payload: "",
          fNews:[],
          news:[],
          popNews:[],

          //label
          schedules:[],

          workEvents: [
          ],
          //charts
          chartData: {
              labels: [],
              datasets: [
                  {
                      label: "Giờ nghỉ",
                      data: [],
                      backgroundColor: "#c685ff",
                      borderColor: "#7917cf",
                      borderWidth: 2
                  },
                  {
                      label: "Giờ làm",
                      data: [],
                      backgroundColor: "#9be67e",
                      borderColor: "#34b304",
                      borderWidth: 2
                  },
                  {
                      label: "Giờ làm thêm",
                      data: [],
                      backgroundColor: "#fccf6d",
                      borderColor: "#e86602",
                      borderWidth: 2
                  },
              ],
          },
          
          // Enrollments
          monthYear: moment().format("YYYY/MM"),
          enrollHistory: [],
          enrollHeader: [
              {text: this.$t("employee_page.home.enrollment_history_table.enroll_date"), value: "enrollDate",width: 120},
              {text: this.$t("employee_page.home.enrollment_history_table.checkin"), value: "checkinTime"},
              {text: this.$t("employee_page.home.enrollment_history_table.checkout"), value: "checkoutTime"},
              {text: this.$t("employee_page.home.enrollment_history_table.location"), value: "department"},
              // {text: "Trễ", value: "late"},
              // {text: "Về sớm", value: "early"},
              // {text: "Số giờ", value: "actualTime"},
          ],
        }
  },
  methods: {
    
    getOS() {
      const ua = navigator.userAgent || navigator.vendor || window.opera

        if (/android/i.test(ua)) return 'android'
        if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'ios'
        if (/windows phone/i.test(ua)) return 'windows-phone'
        if (/windows/i.test(ua)) return 'windows'
        if (/mac os x/i.test(ua)) return 'mac'
        if (/linux/i.test(ua)) return 'linux'

      return 'unknown'
    },
    osDownload() {
      try{ 
        if(this.getOS() == 'android' || this.getOS() == 'windows' ) {
          window.open('https://play.google.com/store/apps/details?id=vn.trungsoncare.trung_son_hrm', '_blank')
        }
        if(this.getOS() == 'ios') {
          const tab = window.open('', '_blank') 
          return this.getApple(false, tab)
        }
      }catch(e) {
        alert(e)
      }
    },

    getApple(isLegacy = false, tab)
    {
        return http.get("employees/apple-download", {
          params: {
            legacy: isLegacy
          }
        }).then(res => {
          tab.location.href = res.data.url
            return 
        })
    },
    scrollLeft() {
      this.$refs.media.scrollLeft({ left: -150, behavior: 'smooth' });
    },
    scrollRight() {
      this.$refs.media.scrollRight({ left: 150, behavior: 'smooth' });
    },

    diffToHuman(value){
        let date = moment(value, "YYYY-MM-DD").locale("vi");
        return moment(date).fromNow();
    },
    formatDate(value, format) {
      return moment(value).format(format)
    },
    checkTime(i) {
      if (i < 10) {i = "0" + i}  // add zero in front of numbers < 10
      return i;
    },
    fetchFeatureNews () {
      return http.get("contents/web/get-news", {
        params: {
          isFeature: true
        }
      }).then(res=> {
        console.log(res.data);
        this.fNews = res.data.filter(x=>x.isFeature && !x.hidden);
        // this.news = res.data.filter(x=>!x.isFeature && !x.hidden);
        // this.popNews = res.data.results.filter(x=>
        //   moment() <= moment(x.createdAt, "YYYY-MM-DD").add(3, "days")
        // )
      })
      .then(() => {
        this.poppingNews();
      });
    },
    fetchPopUp () {
      return http.get("contents/get-news").then(res=> {
        // this.fNews = res.data.results.filter(x=>x.isFeature);
        // this.news = res.data.results.filter(x=>!x.isFeature);
        this.popNews = res.data
      })
      .then(() => {
        this.poppingNews();
      });
    },
    fetchWorkSchedule() {
      let url = `WorkSchedules/employee/${this.user.employeeCode}`
      return http.get(url).then(res => {
        this.schedules = res.data;
      })
    },
    fetchEnrollHistory(){
      return http.get('account/enrollment/').then(res => {
          this.enrollHistory = res.data.items;
      });
    },
    fetchTimesheetInMonth() {
      return http.get('account/timesheet-in-month').then(res => {
        res.data.data.forEach(ts => {
          this.workEvents.push({
            name: `${!ts.isConfirmed ? 0 :ts.validActualTime}h`,
            start: this.formatDate(ts.workDate, 'YYYY-MM-DD'),
            end: this.formatDate(ts.workDate, 'YYYY-MM-DD'),
            color: 'teal lighten-4',
          })

          this.workEvents.push({
            name: `${ts.overtime}h`,
            start: this.formatDate(ts.workDate, 'YYYY-MM-DD'),
            end: this.formatDate(ts.workDate, 'YYYY-MM-DD'),
            color: 'red lighten-4'
          })

          this.workEvents.push({
            name: `${ts.leaveTime}h`,
            start: this.formatDate(ts.workDate, 'YYYY-MM-DD'),
            end: this.formatDate(ts.workDate, 'YYYY-MM-DD'),
            color: 'blue lighten-4',
          })
        });
        console.log(this.events)
      })
    },
    
    getContents() {
      return getContents().then(d => {
        this.sliders = d.data.sliders
        this.news = d.data.news
      })
    },

    initChart(){
      //label
      var labels = [];
      let start = moment().startOf('month');
      let end = moment().endOf('month');
      while(start<=end)
      {
        labels.push(start.format("YYYY-MM-DD"));
        start.add(1, "days");
      }
      this.chartData.labels=labels;
      // this.$refs.chart.update();
      let url = `timesheets/employee/${this.user.employeeCode}`;
      return http.get(url).then(res => {
        let result = res.data;
        console.log(result);
        let work = result.map(x=> x.work);
        let overtime = result.map(x=> x.work);
        let workTime = result.map(x=> {return {date:x.date, leave:x.leave}});
        
        this.chartData.datasets[0].data=[];
        labels.forEach(x=>{
          let item = result.find(z=>z.date==x);
          this.chartData.datasets[0].data.push(!!item?item.leave:0);
          this.chartData.datasets[1].data.push(!!item?item.work:0);
          this.chartData.datasets[2].data.push(!!item?item.overtime:0);
        })
        // leave.forEach(x => {
        //     this.chartData.datasets[0].data.push(x);
        // });
        // this.chartData.datasets[1].data=[];
        // work.forEach(x => {
        //     this.chartData.datasets[1].data.push(x);
        // });
        // this.chartData.datasets[2].data=[];
        // overtime.forEach(x => {
        //     this.chartData.datasets[2].data.push(x);
        // });
        this.$refs.chart.update();
      })
    }
  },

  async mounted() {
    var tokens = this.token.split(".");
    // console.log(atob(tokens[0]));
    // console.log(atob(tokens[1]));
  },
  created()
  {
    this.getContents()
    this.fetchPopUp()
    this.fetchFeatureNews()
    this.fetchWorkSchedule()
    this.fetchEnrollHistory()
    this.initChart()
    this.fetchTimesheetInMonth()
  }
}
</script>

<style scoped>
::v-deep #enroll_table .v-data-table__wrapper {
  scrollbar-width: none;
}
</style>



